import { Component, OnInit } from '@angular/core';
import { WhiteLabelService } from 'src/app/core/services/whitelabel.service';

@Component({
  standalone: false,
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  year: number = new Date().getFullYear();

  constructor(public wl: WhiteLabelService) { }

  ngOnInit() {
  }

}
